import React, { useEffect, useState } from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { SegmentedToggle, UnderlineTabs } from '../components/ui/Tabs';
import { StatCard } from '../components/ui/StatCard';
import { SchoolsTab } from '../components/overview/SchoolsTab';
import { PlansTab } from '../components/overview/PlansTab';
import { DevicesTab } from '../components/overview/DevicesTab';
import { coverageStats } from '../data/plans';
const programOptions = [{
  value: 'optin',
  label: 'Opt-in Program'
}, {
  value: 'group',
  label: 'Group Program'
}];
const optInTabs = [{
  value: 'schools',
  label: 'Schools'
}, {
  value: 'plans',
  label: 'Plans'
}, {
  value: 'devices',
  label: 'Devices'
}];
const groupTabs = [{
  value: 'plans',
  label: 'Plans'
}, {
  value: 'devices',
  label: 'Devices'
}];
export function Overview() {
  const [program, setProgram] = useState('optin');
  const [tab, setTab] = useState('schools');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 320);
    return () => clearTimeout(timer);
  }, [tab, program]);
  function switchProgram(next: string) {
    setProgram(next);
    setTab(next === 'group' ? 'plans' : 'schools');
  }
  const tabs = program === 'optin' ? optInTabs : groupTabs;
  return <>
      <PageHeader title="Overview" subtitle="Plans and Coverage Overview" data-id="element-500" data-mp="2lja4ytsr468l" />

      <div className="flex flex-1 flex-col bg-white px-6 py-5" data-id="element-501" data-mp="3ib3x9z8fsqto">
        <SegmentedToggle label="Program type" options={programOptions} value={program} onChange={switchProgram} data-id="element-502" data-mp="3e9sf2erw77vi" />

        <div className="mt-4 flex flex-wrap gap-3" data-id="element-503" data-mp="39csay9elsf71">
          {program === 'optin' ? <StatCard label="Students Covered" value={coverageStats.studentsCovered} data-id="element-504" data-mp="34dyt64saa212" /> : <>
              <StatCard label="Plans Purchased" value={coverageStats.plansPurchased} data-id="element-505" data-mp="1swpctr4gbq3z" />
              <StatCard label="Devices Covered" value={coverageStats.devicesCovered.toLocaleString()} data-id="element-506" data-mp="1sz21en4psyq0" />
            </>}
        </div>

        <div className="mt-6" data-id="element-507" data-mp="1zd7kk7hrdnx5">
          <UnderlineTabs label="Coverage sections" options={tabs} value={tab} onChange={setTab} data-id="element-508" data-mp="1zc6ao6chb7h0" />
        </div>

        <div className="mt-4 flex flex-1 flex-col" data-id="element-509" data-mp="1lfan78vhddhf">
          {program === 'optin' && tab === 'schools' && <SchoolsTab loading={loading} data-id="element-510" data-mp="1qedtewn75pqz" />}
          {tab === 'plans' && <PlansTab program={program as 'optin' | 'group'} loading={loading} data-id="element-511" data-mp="1bmbwnlgfbcv6" />}
          {tab === 'devices' && <DevicesTab program={program as 'optin' | 'group'} loading={loading} data-id="element-512" data-mp="1gevdcraeqo47" />}
        </div>
      </div>
    </>;
}